import Vue from 'vue';
import Router from 'vue-router';
import monitor from './monitor';
import report from './report';
import Layout from '@/components/Layout';
import alert from './alert';
import store from '@/store';

Vue.use(Router);

/**
 * 使用命令路由导航
 * this.$router.push({ name, params: { prop1, prop2 } })
 *
 * meta
 * requireAuth 需要登录
 */
const router = new Router({
  routes: [
    ...monitor,
    ...report,
    ...alert,
    {
      path: '/',
      redirect: '/index',
    },
    {
      path: '/index',
      component: Layout,
      meta: {
        requireAuth: true,
      },
      children: [
        {
          path: '/index',
          name: 'Home',
          component: () => import('@/views/dashboard'),
          meta: {
            hideCardBodyPadding: true,
            title: '管理控制台',
          },
        },
        {
          path: '/test',
          name: 'Test',
          component: () => import('@/views/test'),
          meta: {
            hideCardBodyPadding: true,
            title: '管理控制台',
          },
        },
        {
          path: '/command-debug',
          name: 'CommandDebug',
          component: () => import('@/views/CommandDebug'),
          meta: {
            title: '命令调试',
          },
        },
        {
          path: '/projects/:projectId',
          name: 'ProjectIndex',
          meta: {
            title: '项目列表',
          },
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import('@/views/profile'),
          meta: {
            title: '个人中心',
          },
        },
      ],
    },
    {
      path: '/sign',
      component: () => import('@/views/sign'),
      name: '登录',
      meta: {
        title: '欢迎使用，请登录',
      },
    },
    {
      path: '*',
      component: () => import('@/views/404'),
      name: '404 Not Found',
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.query.sptoken && to.query.sptoken2) {
    const name = window.atob(to.query.sptoken);
    const password = to.query.sptoken2;
    const verify = 'c675f189-bb5d-4b12-ab6e-fca9cc6897ec';
    store.dispatch('Login', { name, password, verify }).then(() => {
      next();
    }).catch((err) => {
      console.error(err);
    });
  } else {
    next();
  }
});

/**
 * 使用命令路由导航
 * this.$router.push({ name, params: { prop1, prop2 } })
 *
 * meta
 * requireAuth 需要登录
 */
export default router;
